import React from 'react';
import { useTranslation } from 'react-i18next';
import { TDR } from 'tdr-common';
import { cn } from '@/lib/utils';
import { analytics, FILTER_CHANGED, LEAD_GEN_PARTY_SIZE_SELECTED } from '../../../helpers/analytics';
import { useFilterAnalytics } from '../../../helpers/analytics/filterContext';
import { getLeadGenPartySize } from '../../../helpers/open-parameters/getLeadGenPartySize';
import {
	desktopPickerOptionBaseClassName,
	desktopPickerOptionSelectedClassName,
	desktopPickerPartyOptionClassName,
	desktopPickerScrollAreaClassName
} from './desktopParameterPickerStyles';

export interface DesktopPartySizeSelectorProps {
	restaurant?: TDR.Restaurant;
	value?: number;
	onChange: (n: number) => void;
}

export const DesktopPartySizeSelector = ({ restaurant, value, onChange }: DesktopPartySizeSelectorProps) => {
	const { t } = useTranslation();
	const filterCtx = useFilterAnalytics('global explore');
	const { baseMax, leadGenValue } = getLeadGenPartySize(restaurant);
	const rows = Array.from({ length: baseMax }, (_, i) => {
		const idx = i + 1;
		const guestWord =
			idx === 1 ? t('labels.guest', { defaultValue: 'Guest' }) : t('labels.guests', { defaultValue: 'Guests' });
		return { value: idx, label: `${idx} ${guestWord}` };
	});
	if (leadGenValue !== null) {
		rows.push({
			value: leadGenValue,
			label: `${leadGenValue}+ ${t('labels.guests', { defaultValue: 'Guests' })}`
		});
	}

	return (
		<div className={cn('flex flex-col gap-4', desktopPickerScrollAreaClassName)}>
			{rows.map(row => {
				const isSelected = row.value === value;
				return (
					<button
						key={row.value}
						type="button"
						onClick={() => {
							onChange(row.value);
							analytics.track(FILTER_CHANGED, {
								filterName: 'groupSize',
								filterValue: row.value,
								source: 'open_parameters_selector',
								...filterCtx
							});
							if (leadGenValue !== null && row.value === leadGenValue) {
								analytics.track(LEAD_GEN_PARTY_SIZE_SELECTED, {
									source: 'open_parameters_selector',
									partySize: row.value
								});
							}
						}}
						className={cn(
							desktopPickerOptionBaseClassName,
							desktopPickerPartyOptionClassName,
							isSelected && desktopPickerOptionSelectedClassName
						)}
					>
						{row.label}
					</button>
				);
			})}
		</div>
	);
};
